import { getApi } from "../helpers/api";

async function get(endpoint: string, id: any, queryParams: string = "") {
  return await getApi().get(`/${endpoint}/${id}${queryParams}`);
}

export default get;
